import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
class ServiceAdd extends React.Component {
  state = {
    name_en: '',
    name_ar: '',
    type: '',
    image: null,
    isData: false,
  }

  componentDidMount() {
    this.dashbord()
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleChangeImage = ({ target }) => {
    this.setState({
      [target.name]: target.files[0],
    })
  }

  dashbord = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/get-services`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const matchItem = res.data.data.filter((itm) => itm.id == this.props.id)
          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
            })
          }
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  submitForm = () => {
    const formData = new FormData()

    formData.append('name_en', this.state.name_en)
    formData.append('name_ar', this.state.name_ar)
    formData.append('type', this.state.type)

    if (this.state.image && typeof this.state.image == 'object') {
      formData.append('image', this.state.image)
    }

    var request
    if (this.props.id) {
      formData.append('id', this.props.id)

      request = axios.post(Constant.getAPI() + '/admin/update-service', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    } else {
      request = axios.post(Constant.getAPI() + '/admin/add-service', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    }

    request
      .then((res) => {
        if (res.status) {
          Swal.fire({
            title: this.props.id ? 'Service Updated Successfully!' : 'Service Added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        window.location.href = `#/client-setting`
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isData: false })
      })
  }

  onSaveData = () => {
    this.setState({ isData: true }, this.submitForm)
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">English Name</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_en"
                    placeholder="English Name"
                    onChange={this.handleChange}
                    value={this.state.name_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Arabic Name</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="name_ar"
                    placeholder="Arabic Name"
                    onChange={this.handleChange}
                    value={this.state.name_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Type</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="type"
                    placeholder="Type"
                    onChange={this.handleChange}
                    value={this.state.type}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image:</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="image"
                        name="image"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                  </div>
                  {this.state.image &&
                    (typeof this.state.image == 'object' ? (
                      <img
                        width="250px"
                        height="200px"
                        src={URL.createObjectURL(this.state.image)}
                        alt="img"
                      />
                    ) : (
                      <img
                        width="250px"
                        height="200px"
                        src={Constant.getImage() + this.state.image}
                        alt="img"
                      />
                    ))}

                  {/* {this.props.id ? (
                    <img
                      width="250px"
                      height="200px"
                      src={Constant.getImage() + this.state.image}
                      alt="img"
                    />
                  ) : (
                    <img
                      width="250px"
                      height="200px"
                      src={this.state.image}
                      alt="img"
                    />
                  )} */}
                </div>
              </div>
            </div>
          </div>

          <div className="card-footer">
            <div className="row">
              <div className="text-right col-6 offset-6">
                <Link
                  to={`/client-setting`}
                  className="btn btn-outline-secondary m-2 "
                >
                  <i className="icofont icofont-rounded-double-left"></i>
                  Back
                </Link>
                {this.state.isData ? (
                  <button
                    className="btn btn-grd-disabled mr-2"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ServiceAdd
